<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div
          class="left-side-icon"
          @click="showMenu"
          @mouseover="showMenu"
        ></div>

        <!-- 左侧菜单 -->
        <div
          class="left-side-menu"
          v-if="isShowMenu"
          @click="hideMenu"
          @mouseleave="hideMenu"
        >
          <div
            class="menu-list"
            :class="item.id == isActive ? 'menu-active' : ''"
            v-for="(item, index) in menuList"
            :key="index"
            @click="menuChange(item, index)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>

        <div class="d-flex jc-between mg-top">
          <div class="d-flex aside-width">
            <div class="react-left mr-4 react-l-s">
              <!-- <span class="react-before"></span> -->
              <span class="text"
                >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span
              >
            </div>
            <div class="react-left bg-color-blue mr-3">
              <span class="text"></span>
            </div>
          </div>
          <div class="show-title">
            <div class="ft-size">平高智联充电运营大数据平台</div>
          </div>
          <div
            class="d-flex aside-width"
            style="justify-content: space-between"
          >
            <div class="d-flex">
              <div class="react-left bg-color-blue mr-4 trf-sk-1">
                <span class="text"></span>
              </div>
              <div class="react-left react-l-s trf-sk-2">
                <span
                  style="
                    display: inline-block;
                    transform: skewX(55deg);
                    position: absolute;
                    top: 6px;
                    right: 32px;
                  "
                  ><img
                    width="24px"
                    height="24px"
                    src="../../assets/loginout-2.png"
                    @click="loginOut"
                /></span>
              </div>
            </div>
            <div><img src="../../assets/loginout-2.png" /></div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="d-flex flex mg-top mg-position">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex dv-40">
            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#030D45']" />
            <dv-decoration-6
              class="dv-dec-6 dv-6-size"
              :color="['#50e3c2', '#67a1e5']"
            />
            <dv-decoration-6
              class="dv-dec-6 dv-6-size"
              :reverse="true"
              :color="['#50e3c2', '#67a1e5']"
            />
            <dv-decoration-8
              class="dv-dec-8"
              :reverse="true"
              :color="['#568aea', '#030D45']"
            />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>

        <!-- 第三行 -->
        <div>
          <div class="content-grid-flex">
            <!-- 第一列 -->
            <div class="column first-column">
              <div class="position-box">
                <div class="flex-row">
                  <div class="title-bicycle">充电汽车管理系统</div>
                  <div class="btn-box province-box" @click="provinceListShow">
                    {{ selectedProvinceName }}
                    <i
                      style="margin: 0 5px"
                      :class="
                        isProvinceListShow
                          ? 'el-icon-caret-top'
                          : 'el-icon-caret-bottom'
                      "
                    ></i>
                  </div>
                  <ul class="province-list" v-if="isProvinceListShow">
                    <li
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :class="item.isSelected ? 'selected' : ''"
                      @click="selectProvince(item)"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
                <option1Vue :level="level" :regionId="regionId" ref="option1Vue"></option1Vue>
              </div>
              <div>
                <option6Vue
                  :level="level"
                  :regionId="regionId"
                  class="row3-height row-bottom"
                  ref="option6Vue"
                ></option6Vue>
              </div>
              <div>
                <option7Vue
                  :level="level"
                  :regionId="regionId"
                  class="row3-height"
                  ref="option7Vue"
                ></option7Vue>
              </div>
            </div>

            <!-- 第二列 -->
            <div class="column second-column">
              <div style="height: 492px">
                <option2Vue :level="level" :regionId="regionId" ref="option2Vue"></option2Vue>
              </div>
              <div class="row2-height" style="margin-bottom: 10px">
                <option4Vue :level="level" :regionId="regionId" ref="option4Vue"></option4Vue>
              </div>
              <div class="row2-height teshu-border">
                <option5Vue :level="level" :regionId="regionId" ref="option5Vue"></option5Vue>
              </div>
            </div>

            <!-- 第三列 -->
            <div class="column third-column">
              <div>
                <option3Vue :level="level" :regionId="regionId" ref="option3Vue"></option3Vue>
              </div>
              <div class="row3-height row-bottom">
                <option8Vue :level="level" :regionId="regionId" ref="option8Vue"></option8Vue>
              </div>
              <div class="row3-height">
                <option9Vue :level="level" :regionId="regionId" ref="option9Vue"></option9Vue>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../../utils/drawMixin";
import { formatTime } from "../../utils/index.js";
import option1Vue from "./option1.vue";
import option2Vue from "./option2.vue";
import option3Vue from "./option3.vue";
import option4Vue from "./option4.vue";
import option5Vue from "./option5.vue";
import option6Vue from "./option6.vue";
import option7Vue from "./option7.vue";
import option8Vue from "./option8.vue";
import option9Vue from "./option9.vue";
export default {
  mixins: [drawMixin],
  data() {
    return {
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      isShowMenu: false,
      isActive: 1,
      menuList: [
        {
          name: "充电运营大数据平台",
          id: 1,
        },
        {
          name: "电动自行车管理系统",
          id: 2,
        },
        {
          name: "电动汽车管理系统",
          id: 3,
        },
        {
          name: "设备监管系统",
          id: 4,
        },
        {
          name: "换电管理系统",
          id: 5,
        },
        {
          name: "源网荷储系统",
          id: 6,
        },
        {
          name: "数据分析系统",
          id: 7,
        },
      ],
      level: 0,
      regionId: "",
      selectedProvinceName: "全国",
      isProvinceListShow: false,
      provinceList: [],
    };
  },
  components: {
    option1Vue,
    option2Vue,
    option3Vue,
    option4Vue,
    option5Vue,
    option6Vue,
    option7Vue,
    option8Vue,
    option9Vue,
  },
  mounted() {
    this.timeFn();
    this.cancelLoading();
    console.log(this.$route.query);
    this.isActive = this.$route.query.currentMenu;
    this.getProvinceList();
  },
  beforeDestroy() {
    clearInterval(this.timing);
  },
  methods: {
    showMenu() {
      this.isShowMenu = true;
    },
    hideMenu() {
      this.isShowMenu = false;
    },
    menuChange(item, index) {
      this.isActive = item.id;
      if (item.id == 1) {
        this.$router.push({
          path: "/home",
        });
      } else if (item.id == 2) {
        this.$router.push({
          path: "/bicycleSystem",
          query: {
            currentMenu: item.id,
          },
        });
      } else if (item.id == 3) {
        this.$router.push({
          path: "/carSystem",
          query: {
            currentMenu: item.id,
          },
        });
      }
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    // 退出登录
    loginOut() {
      this.$cookie.set("merchantId", "");
      this.$cookie.set("Authorization", "");
      this.$router.replace({ name: "login" });
    },

    // 获取省份
    async getProvinceList() {
      const { data: res } = await this.$http.get(
        "/admin/api/realTime/getRegionByProvince"
      );
      this.provinceList = res.data;
      // 每一项，加入 是否选中的属性
      this.provinceList.map((item) => {
        item.isSelected = false;
        // item.name = item.name
      });
      // 加入全国
      this.provinceList.unshift({
        name: "全国",
        code: "",
        isSelected: true,
      });
    },
    // 是 全国 还是 各省 的下拉选择
    provinceListShow() {
      // debugger;
      this.isProvinceListShow = !this.isProvinceListShow;
      this.isDevTypeListShow = false;
    },
    // 选择省
    selectProvince(item) {
      item.isSelected = true;
      this.regionId = item.id;
      if (item.name == "全国") {
        this.level = 0;
      } else {
        this.level = 1;
      }
      this.isProvinceListShow = false;
      this.selectedProvinceName = item.name;
      // 父组件的值发生变化，主动调用子组件的函数，重新获取数据
      this.provinceList.map((province) => {
        if (province.id != item.id) {
          province.isSelected = false;
        }
      });
      // this.initDataSouce();
      this.$nextTick(() => {
        this.$refs.option1Vue.getoption1DataMoney();
        this.$refs.option1Vue.getoption1DataPort();
        this.$refs.option1Vue.getoption1DataElec();
        this.$refs.option2Vue.getTimeData();
        this.$refs.option2Vue.getoption2Dataleft();
        this.$refs.option2Vue.getoption2DataRight();
        this.$refs.option3Vue.getSouceData();
        this.$refs.option4Vue.getoption4Data();
        this.$refs.option5Vue.getoption5Data();
        this.$refs.option6Vue.getSouceData();
        this.$refs.option7Vue.getoption7Data();
        this.$refs.option8Vue.getoption8Data();
        this.$refs.option9Vue.getoption9Data();
      //   this.$refs.optionSixVue.getoption6Data();
      //   this.$refs.optionSevenVue.getoption7Data();
      //   this.$refs.optionEightVue.getoption8Data();
      //   this.$refs.optionNineVue.getoption9Data();
      //   this.$refs.optionTwoVue.getTwoEchartsData();
      //   this.$refs.optionTwoVue.init();
      //   this.$refs.option3Vue.getoption3DataPort();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index.scss";
.bg {
  width: 100%;
  height: 100%;
  padding: 16px 16px 0 16px;
  background: url("../../assets/pgzl-screen-bg.png");
  background-size: cover;
  background-position: center center;
}
.host-body {
  position: relative;
  .left-side-icon {
    width: 46px;
    height: 320px;
    background-image: url("../../assets/side-img/side-icon.png");
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 120px;
    z-index: 999;
  }
  .left-side-menu {
    width: 445px;
    height: 880px;
    background-image: url("../../assets/side-img/side-bg.png");
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    top: 150px;
    z-index: 999;
    padding: 110px 0;
    .menu-list {
      width: 260px;
      height: 60px;
      background-image: url("../../assets/side-img/side-menu-default.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 60px;
      margin-bottom: 40px;
      color: #75b8ff;
      font-size: 21px;
    }
    .menu-list:hover {
      background-image: url("../../assets/side-img/side-menu-current.png");
      background-size: 100% 100%;
      color: #ffbb00;
      font-weight: bold;
      text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
    }
    .menu-active {
      background-image: url("../../assets/side-img/side-menu-current.png");
      background-size: 100% 100%;
      color: #ffbb00;
      font-weight: bold;
      text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
    }
  }
}
.mg-top {
  margin-top: 8px;
  .dv-40 {
    width: 40%;
  }
}

.mg-position {
  position: relative;
  .title-box {
    width: 616px;
    background: linear-gradient(180deg, #b3ccff 0%, #36a3ff 100%);
    position: absolute;
    top: 0px;
    .title1 {
      font-size: 40px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 5px;
      text-shadow: 0px 2px 8px rgba(96, 255, 249, 0.5);
      position: absolute;
      bottom: 0;
      left: 44%;
      transform: translate(-50%);
    }
    .dv-dec-6 {
      position: absolute;
      bottom: -30px;
      left: 45%;
      width: 250px;
      height: 8px;
      transform: translate(-50%);
    }
  }
}
.content-grid-flex {
  display: grid;
  grid-template-columns: 25% 50% 25%;
}
.row-bottom {
  margin-bottom: 10px;
}
.row1-height {
  height: 460px;
  // border: 1px solid #f0f;
}
.row1-height-option2 {
  height: 500px;
}
.row2-height {
  // border: 1px solid #ff0;
  height: 200px;
  background-image: url("../../assets/border-large.png");
  background-size: 100% 100%;
  margin: 0 10px;
}
.teshu-border {
  height: 220px;
  background-image: url("../../assets/border-large.png");
  background-size: 100% 100%;
  // margin: 0 20px;
}
.row3-height {
  // border: 1px solid #0ff;
  height: 220px;
  background-image: url("../../assets/border-small-bg.png");
  background-size: 100% 100%;
}
.content-grid {
  margin-bottom: 30px;
  .line-border {
    border: 1px solid #f0f;
    height: 450px;
    display: flex;
    .box-img {
      width: 110px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      // background-image: url("../../assets/border-default.png");
      // background-size: 100% 100%;
    }
    .box-img:nth-child(2) {
      margin-left: -10px;
    }
    .box-img:nth-child(3) {
      margin-left: -10px;
    }
    .box-img:hover {
      // background-image: url("../../assets/border-current.png");
      // background-size: 100% 100%;
    }
  }
}
.content-grid-2 {
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: 50% 50%;
  .line-border {
    border: 1px solid #ff0;
    height: 200px;
  }
}
.content-grid-3 {
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  .line-border {
    border: 1px solid #0ff;
    height: 200px;
  }
}


.position-box {
  position: relative;
  .flex-row {
    display: flex;
    position: absolute;
    top: -36px;
    left: 0;
    .title-bicycle {
      color: #75b8ff;
      font-size: 26px;
      line-height: 30px;
    }
    .btn-box {
      // width: 120px;
      padding: 0 5px 0 15px;
      height: 30px;
      border: 1px solid #0096ff;
      border-radius: 20px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .province-box {
      position: absolute;
      left: 250px;
      top: 0px;
      width: 100px;
    }
    .province-list {
      height: 200px;
      position: absolute;
      left: 250px;
      top: 34px;
      overflow-x: scroll;
      width: 100px;
      z-index: 100;
    }
  }
}
ul {
  background: rgba(10, 31, 116, 0.89);
  box-shadow: 0px 0px 3px 0px rgba(0, 150, 255, 0.6);
  border-radius: 10px;
  border-image: linear-gradient(
      180deg,
      rgba(107, 212, 250, 1),
      rgba(0, 87, 194, 1)
    )
    1 1;
  padding: 15px;
  li {
    margin-bottom: 10px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  li:hover {
    color: #00ecfc;
  }
  .selected {
    color: #00ecfc;
  }
  li:last-child {
    margin-bottom: 0px;
  }
}
/*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: rgba(10, 31, 116, 0.89);
}
/*定义滚动条轨道
 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(10, 31, 116, 0.89);
}
/*定义滑块
 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #00ecfc;
}
</style>



// WEBPACK FOOTER //
// src/views/car-system/index.vue